window.Accountant = {

	deleteAccountantStaff: function() {
		$.get('?_f=prefsAccount&action=deleteAccountant', function(data){
			window.location.reload();
		});
	}

};
 